export const supportEmail = "support@lvt.com";
export const supportKnowledgeBase = "support.liveviewtech.com";
export const supportVMSBetaGuide = "https://support.liveviewtech.com/article/265-vms-user-guide-beta";
export const supportPhone = "888-588-9408";
export const supportHours = "M-F 6am-8pm MT";
